<template>
	<div class="" :class="expandAdvancedFields ? 'p-2 lg:p-3' : 'p-2 lg:p-6'">
		<div
			class="bg-white mt-6 w-full shadow-xl border-gray-150 border-t rounded-lg"
			:class="expandAdvancedFields ? 'lg:p-3' : ''"
		>
			<div
				id="advanced-upload"
				v-if="expandAdvancedFields"
				class="px-4 pb-6 pt-4 border-b"
			>
				<h5 class="font-medium text-gray-900 text-xl truncate">
					{{ __("Upload picture or file") }}
				</h5>

				<thread-show-post-upload
					:thread="thread"
					class="mt-4"
					v-on:done="expandAdvancedFields = false"
				/>

				<!-- <hr /> -->
				<div class="relative mt-3">
					<div class="absolute inset-0 flex items-center" aria-hidden="true">
						<div class="w-full border-t border-gray-300"></div>
					</div>
					<div class="relative flex justify-center">
						<span class="px-2 bg-white text-sm text-gray-500">
							{{ __("or") }}
						</span>
					</div>
				</div>

				<h5 class="mt-2 font-medium text-gray-900 text-xl truncate">
					{{ __("Change status") }}
				</h5>

				<thread-show-post-status
					:thread="thread"
					v-on:done="expandAdvancedFields = false"
					class="mt-4 mb-1"
				/>
			</div>

			<div class="p-4 flex space-x-4 items-end">
				<button
					class="bg-gray-100 flex text-gray-500 px-2 py-2 font-medium rounded-lg focus:ring-2 focus:ring-gray-200"
					v-on:click.stop="toggleUpload()"
				>
					<!-- show upload button should trigger scroll to -->
					<ui-icon
						class="h-6 w-6 my-px"
						:name="expandAdvancedFields ? 'minus' : 'plus'"
						stroke-width="2"
					/>
				</button>
				<div class="flex-grow">
					<div
						class="border border-gray-300 rounded-lg shadow-sm md:overflow-hidden focus-within:border-orange-500 focus-within:ring-1 focus-within:ring-orange-500"
					>
						<!-- -m-px -->
						<ui-textarea
							class="block w-full max-w-prose py-2 border-0 resize-none focus:ring-0"
							:placeholder="__('Personal message')"
							v-model="message"
							@keydown="keydownHandler"
						/>
					</div>
					<!-- <input type="text" name="message" id="message" > -->
				</div>

				<div class="align-self-end">
					<ui-button
						v-on:click="postMessage"
						v-bind:disabled="buttonLock"
						type="primary"
						class="!px-2 !py-2"
					>
						<span class="sr-only">Send</span>
						<ui-icon name="send" stroke-width="2" class="w-6 h-6 my-px" />
					</ui-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		thread: {
			type: Object,
			required: true,
		},
	},
	data: function () {
		return {
			message: "",
			threadEndpoint: window.baseUrl + "/api/thread/" + this.thread.id,
			expandAdvancedFields: false,
			buttonLock: false,
		};
	},
	methods: {
		keydownHandler: function (e) {
			if (e.keyCode == 13 && e.shiftKey) {
				e.preventDefault();
				this.postMessage();
			}
		},

		postMessage: function () {
			let thread = this.thread,
				that = this;
			if (this.message.match(/^\s*$/)) {
				// only whitespace, ignore!
			} else {
				that.buttonLock = true;
				axios
					.post(this.threadEndpoint + "/event", {
						data: {
							message: this.message,
						},
					})
					.then(function (response) {
						that.message = "";
						console.log("response", response);
						that.$bus.$emit("thread-update", response.data.data);
					})
					.catch(function (e) {
						alert("error");
						console.log(e);
					})
					.finally(function () {
						that.buttonLock = false;
					});
			}
		},
		toggleUpload() {
			this.expandAdvancedFields = !this.expandAdvancedFields;
			this.tryScrollDown();
		},
		tryScrollDown() {
			this.$nextTick(function () {
				let $t = document.getElementById("thread"),
					$lastItem = document.getElementById("last-item");
				if ($t && $lastItem) {
					$t.scrollTop = $lastItem.offsetTop;
				}
			});
		},
	},
	mounted() {
		this.tryScrollDown();
	},
};
</script>
